import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";

export const PaymentSuccess = () => {
  const [params] = useSearchParams();
  const [state, setState] = useState("checking");
  useEffect(() => {
    const id = params.get("session_id");
    if (!id) { setState("failed"); return undefined; }
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${id}`);
        if (data.payment_status === "paid") return setState("paid");
        if (["expired", "failed"].includes(data.payment_status)) return setState("failed");
      } catch (e) {
        if (e.response?.status === 404) return setState("failed");
      }
      tries += 1;
      if (tries >= 15) return setState("timeout");
      timer = setTimeout(poll, 2000);
      return undefined;
    };
    poll();
    return () => clearTimeout(timer);
  }, [params]);
  return (
    <section className="mx-auto max-w-2xl px-4 py-24 text-center" data-testid="payment-success-page">
      {state === "checking" && <><Loader2 className="mx-auto h-10 w-10 animate-spin text-[#1F8A8B]" /><h1 className="mt-6 text-3xl font-bold text-[#0B192C]">Confirming your payment…</h1></>}
      {state === "paid" && <><CheckCircle2 className="mx-auto h-10 w-10 text-[#1F8A8B]" /><h1 className="mt-6 text-3xl font-bold text-[#0B192C]" data-testid="payment-paid">Your subscription is active</h1><p className="mt-3 text-slate-600">Thank you. Your workspace subscription has started.</p></>}
      {state === "failed" && <><XCircle className="mx-auto h-10 w-10 text-red-600" /><h1 className="mt-6 text-3xl font-bold text-[#0B192C]" data-testid="payment-failed">The payment didn't go through</h1><p className="mt-3 text-slate-600">No money was taken. You can try again.</p></>}
      {state === "timeout" && <><h1 className="mt-6 text-3xl font-bold text-[#0B192C]" data-testid="payment-pending">Still confirming</h1><p className="mt-3 text-slate-600">This is taking longer than usual. Check Plan & partnership in a minute.</p></>}
      <Link to="/app/billing" data-testid="payment-back-billing" className="btn-teal mt-8 inline-flex">Go to Plan & partnership</Link>
    </section>
  );
};

export const PaymentCancel = () => (
  <section className="mx-auto max-w-2xl px-4 py-24 text-center" data-testid="payment-cancel-page">
    <h1 className="text-3xl font-bold text-[#0B192C]">Payment cancelled</h1>
    <p className="mt-3 text-slate-600">Nothing was charged. You can subscribe whenever you're ready.</p>
    <Link to="/app/billing" data-testid="payment-cancel-back" className="btn-teal mt-8 inline-flex">Back to Plan & partnership</Link>
  </section>
);
